var exports = {
  "Lg": "GuildSidebarSkeleton.module__navigation___enRsRU",
  "X9": "GuildSidebarSkeleton.module__detachedBanner___enRsRU",
  "GG": "GuildSidebarSkeleton.module__topSpacer___enRsRU",
  "dl": "GuildSidebarSkeleton.module__membersSection___enRsRU",
  "ne": "GuildSidebarSkeleton.module__membersSeparator___enRsRU",
  "vd": "GuildSidebarSkeleton.module__bottomDropZone___enRsRU",
  "TN": "GuildSidebarSkeleton.module__groups___enRsRU",
  "Os": "GuildSidebarSkeleton.module__group___enRsRU",
  "nM": "GuildSidebarSkeleton.module__row___enRsRU",
  "bQ": "GuildSidebarSkeleton.module__rowCategory___enRsRU",
  "me": "GuildSidebarSkeleton.module__categoryCaret___enRsRU",
  "et": "GuildSidebarSkeleton.module__rowChannel___enRsRU",
  "Ec": "GuildSidebarSkeleton.module__rowMembers___enRsRU",
  "p": "GuildSidebarSkeleton.module__channelIcon___enRsRU",
  "US": "GuildSidebarSkeleton.module__bottomSpacer___enRsRU",
};

module.exports = exports;
